
import {addEventAttendeeReceiptDetails, addEventReceiptImageThumbnail, getSpecificEventReceiptDetails} from "../Receipts/ReceiptDBFunctions";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {addEventActivity} from "../Activities/BrowserDatabaseFunctions";
import {addEventReceipt} from "../Receipts/BrowserDatabaseFunctions";

export async function E_addEventReceiptResults(_incoming) {
    console.log("E_addEventReceiptResults : ", _incoming);

    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newReceipt = _incoming.receipt; // should already contain { id, temp_id?, ... }

        if (!eventId || !newReceipt) {
            console.error("Missing event_id or receipt in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            await addEventReceipt(eventId, newReceipt);
            console.log("Receipt added successfully");
        } catch (error) {
            console.error("Error adding Receipt to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
}

export function E_uploadEventAttendeeReceiptThumbnailImageResults(_incoming, PA_GlobalObject, set_PA_GlobalObject) {
    console.log("E_uploadEventAttendeeReceiptThumbnailImageResults : ", _incoming);

    try {

        const _result = _incoming.result;

        if (_result === "ok"){

            try {
                const { receipt_id, event_id, thumbnail_data } = _incoming;

                addEventReceiptImageThumbnail(event_id, receipt_id, thumbnail_data)
                    .then(success => {
                        if (success) {
                            if (PA_GlobalObject.Planning.id === event_id){

                                set_PA_GlobalObject((prev) => ({
                                    ...prev,
                                    Planning: {
                                        ...prev.Planning,
                                        receipts: prev.Planning.receipts.map((receipt) =>
                                            receipt.id === receipt_id
                                                ? {
                                                    ...receipt,
                                                    thumbnail_data: thumbnail_data,
                                                    thumbnail_finished: true
                                                }
                                                : receipt
                                        ),
                                    },
                                }));

                            }
                        } else {
                            console.error("Failed to save receipt image to browser DB");
                        }
                    })
                    .catch(error => {
                        console.error("Error saving receipt image: ", error);
                    });


            } catch (error) {
                console.error("Unexpected error: ", error);
            }

        }

    } catch (e){
        console.log("ERROROROR : "+e);
    }

}

export default function E_uploadEventAttendeeReceiptImageResults(_incoming, PA_GlobalObject, set_PA_GlobalObject) {
    console.log("E_uploadEventAttendeeReceiptImageResults : "+JSON.stringify(_incoming, null, '\t'));

    /*
        this brings in the thumbnail and full size image
     */

    try {

        const { event_id, receipt_id, full_data, thumbnail_data } = _incoming;

        addEventAttendeeReceiptDetails(event_id, receipt_id, full_data, thumbnail_data)
            .then(success => {
                if (success) {
                    if (PA_GlobalObject.Planning.id === event_id){

                        set_PA_GlobalObject((prev) => ({
                            ...prev,
                            Planning: {
                                ...prev.Planning,
                                receipts: prev.Planning.receipts.map((receipt) =>
                                    receipt.id === receipt_id
                                        ? {
                                            ...receipt,
                                            full_data: full_data,
                                            full_data_loaded: true,
                                            thumbnail_data: thumbnail_data,
                                            thumbnail_finished: true
                                        }
                                        : receipt
                                ),
                            },
                        }));

                    }
                } else {
                    console.error("Failed to save receipt image to browser DB");
                }
            })
            .catch(error => {
                console.error("Error saving receipt image: ", error);
            });

    } catch (e){
        console.log("ERROROROR : "+e);
    }

}

export function E_getEventReceiptImageThumbnailResults(_incoming, _planning) {
    console.log("E_getEventReceiptImageThumbnailResults : "+JSON.stringify(_planning, null, '\t'));

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    /*
        the receipt image details are already in the Event but we needed to fetch the thumbnail data from the server
     */
    try {

        const _result = _incoming.result;

        if (_result === "ok"){

            try {
                /*
                    get the thumbnail details from the Event receipt
                 */
                console.log("getSpecificEventReceiptDetails");
                getSpecificEventReceiptDetails(_incoming.event_id, _incoming.receipt_id).then(_db_receipt => {

                    console.log("the resolved receipt : "+_db_receipt);

                    if (_db_receipt) {
                        //update the Event receipt in the browser database
                        addEventReceiptImageThumbnail(_incoming.event_id, _incoming.receipt_id, _incoming.thumbnail_data).then(_success => {
                            console.log("addEventReceiptImageThumbnail success : "+_success);

                            if (_success){

                                if (PA_GlobalObject.Planning.id === _incoming.event_id) {
                                    const existingReceipt = PA_GlobalObject.Planning.receipts.find(receipt => receipt.id === _incoming.receipt_id);

                                    if (existingReceipt) {
                                        existingReceipt.thumbnail_data = _incoming.thumbnail_data;
                                        existingReceipt.thumbnail_loaded = true;
                                    } else {
//                                    Planning.receipts.push(newReceipt);
                                    }
                                }
                            }

                        })

                    } else {
                        console.error("Failed to find receipt image in browser DB");
                    }
                })
                    .catch(error => {
                        console.error("Error saving receipt image: ", error);
                    });

            } catch (error) {
                console.error("Unexpected error: ", error);
            }

        }

    } catch (e){
        console.log("ERROROROR : "+e);
    }

}

export function E_getEventReceiptImageFullSizeResults(_incoming) {
    console.log("E_getEventReceiptImageFullSizeResults");


    //update the browser IndexedDB database

    //if this image is for the same Event that may be loaded then update that as well

}

export function E_updateEventAttendeeReceiptImagePrivateResults(_incoming) {
    console.log("E_updateEventAttendeeReceiptImagePrivateResults");


    //update the browser IndexedDB database

    //if this image is for the same Event that may be loaded then update that as well

}

export function E_deleteEventReceiptImageResults(_incoming) {
    console.log("E_deleteEventReceiptImageResults");


    //update the browser IndexedDB database

    //if this image is for the same Event that may be loaded then update that as well

}


